import { render, staticRenderFns } from "./NormalSearchNav230.vue?vue&type=template&id=6156be1c&scoped=true&"
import script from "./NormalSearchNav230.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav230.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6156be1c",
  null
  
)

export default component.exports